
    <app-documentsearch #docSearch></app-documentsearch>

    <div class="row">
    
        <div class="col">
    
            <label *ngIf="!docHaveData">{{ docMessage }}</label>
    
            <label *ngIf="docHaveData && documentList.length == 0">No posee información de documentos para mostrar</label>
    
            <table class="table table-sm" *ngIf="docHaveData && documentList.length > 0">
                <thead style="margin-top: 10px;">
                    <tr>
                        <th scope="col" width="20%">Fecha Reg.</th>
                        <th scope="col" width="20%">Fecha Cre.</th>
                        <th scope="col" width="20%">DocNum</th>
                        <th scope="col" width="20%">NumRJ</th>
                        <th scope="col" width="10%">Almacén</th>
                        <th scope="col" width="10%">Estado</th>                        
                        <th scope="col" width="10%" *ngIf="doctype == docArInv"> Obj Recibido</th>
                        <th scope="col" width="10%" *ngIf="doctype == docCredit"> Obj Enviado</th>
                        <th scope="col" width="10%" *ngIf="doctype == docNotDeb"> Obj Recibido</th>
                    </tr>
                </thead>
                <tbody class="tableScroll" style="margin-bottom: 30px;">
                    <tr *ngFor="let doc of documentList">
                        <td width="20%">{{ doc.DocDate | date:"dd/MM/yyyy" }}</td>
                        <td width="20%">{{ doc.CreateDate | date:"dd/MM/yyyy" }}</td>
                        <td width="20%">{{ doc.DocNum }}</td>
                        <td width="20%">{{ doc.NumDocRJ }}</td>
                        <td *ngIf="doc.Almacen === 'L'" width="10%">Limón</td>
                        <td *ngIf="doc.Almacen === 'C'" width="10%">Caldera</td> 
                        <td *ngIf="doc.Almacen != 'C' && doc.Almacen != 'L'" width="10%">N/A</td>                          
                        <td width="10%" class="icono">
                            <span class="fa fa-eye" (click)="ViewDocData(doc.CreateDate, doc.ClavisResponse, doc.ClavisResponseDate, doc.RJResponseDate, doc.RJResponse, doc.RJStatusDetails, contentDoc)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="Examinar"></span>                                                
                        </td>
                        <td width="10%" class="icono">
                            <span  *ngIf="doctype == docArInv" class=" fa fa-info-circle " (click)="ViewDocDataInfo(doc.ObjReceivedFromRJ, contentDocInfo)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="información"></span>                                                
                            <span *ngIf="doctype == docCredit" class=" fa fa-info-circle " (click)="ViewDocDataInfo(doc.DocToSendRJ, contentDocInfo)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="información"> </span>                                                     
                            <span  *ngIf="doctype == docNotDeb" class=" fa fa-info-circle " (click)="ViewDocDataInfo(doc.ObjReceivedFromRJ, contentDocInfo)" placement="left" triggers="mouseenter:mouseleave" ngbPopover="información"></span>                                                                 
                        </td>
                    </tr>
                </tbody>
            </table>
    
        </div>
    
    </div>


<ng-template #contentDoc let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Detalles</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">       
        <div>
            <p><b>Detalle RJ</b></p>
            <p>{{RJStatusDetails}}</p>
            <p>{{RJResponse}}</p>
            <p>{{RJResponseDate}}</p>
            <p><b>Detalle Clavis</b></p>
            <p>{{CreateDate}}</p>
            <p>{{ClavisResponse}}</p>
            <p>{{ClavisResponseDate}}</p>
        </div>                
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
</ng-template>

<ng-template #contentDocInfo let-modal>
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="doctype == docArInv">Obj Recibido</h4>
        <h4 class="modal-title"  *ngIf="doctype == docCredit">Obj Enviado</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">       
        <div>
            <pre>{{SendAndReciveDetails | json}}</pre>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
</ng-template>
 

  